export const MAC_COLUMN = "Mac address";
export const DURATION_COLUMN = "Duración";
export const OS_COLUMN = "Dispositivo";
export const REVIEW_COLUMN = "Calificación";
export const SENTIMENT_COLUMN = "Emoción";